import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { useI18n } from '../../../../../../application/language/useI18n';
import { IUnitCardModel } from '../../../../../../service/unit/interface/IUnitCardModel';
import { OverflownContent } from '../../../LearningUnitPreviewPage/shared/OverflownContent';
import { Colors } from '../../../../../design/color/Colors';

type Props = {
  unit?: IUnitCardModel;
  status: 'important' | 'unimportant';
};

const infoIcon = <InfoOutlinedIcon sx={{ color: Colors.primary, width: '18px', height: '18px' }} />;

const useStyles = makeStyles(() => ({
  header: { display: 'flex', justifyContent: 'space-between', marginBottom: '16px', gap: '8px' },
  groupTitle: {
    lineHeight: '28px',
    fontWeight: 600,
    fontSize: '20px',
    cursor: 'pointer',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    whiteSpace: 'normal',
    lineClamp: 2,
  },
  badgeImportant: {
    borderColor: Colors.primary,
    color: Colors.primary,
    borderWidth: '1px',
    borderStyle: 'solid',
    height: 'fit-content',
    borderRadius: '16px',
    padding: '4px 8px',
    display: 'flex',
    gap: '4px',
  },
  badgeUnimportant: {
    borderColor: Colors.textTertiary,
    color: Colors.textPrimary,
    borderWidth: '1px',
    borderStyle: 'solid',
    height: 'fit-content',
    borderRadius: '16px',
    padding: '4px 8px',
    display: 'flex',
    gap: '4px',
  },
  iconFont: { fontSize: '4px' },
  titleFont: { fontSize: '12px' },
}));

export const UnitCardHeader = observer(({ unit, status }: Props) => {
  const i18n = useI18n();
  const classes = useStyles();

  const statusTitle = status === 'important'
    ? i18n.translate('phrases.mandatory')
    : i18n.translate('phrases.optional');

  return (
    <Box className={classes.header}>
      <OverflownContent contentClasses={classes.groupTitle}>{unit?.settings.titleHeading}</OverflownContent>
      <Box className={status === 'important' ? classes.badgeImportant : classes.badgeUnimportant}>
        <Box className={classes.iconFont}>{status === 'important' ? infoIcon : undefined}</Box>
        <Box className={classes.titleFont}>{statusTitle}</Box>
      </Box>
    </Box>
  );
});
